const BANGLADESH_TIME_ZONE = 'Asia/Dhaka';
const ISO_DATE_LENGTH = 10;
const MISSING_PART_VALUE = '00';

const BANGLADESH_WALL_CLOCK_FORMAT = new Intl.DateTimeFormat('en-CA', {
  timeZone: BANGLADESH_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

function getBangladeshNow(): string {
  const parts = BANGLADESH_WALL_CLOCK_FORMAT.formatToParts(new Date());
  const readPart = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((part) => part.type === type)?.value ?? MISSING_PART_VALUE;

  return `${readPart('year')}-${readPart('month')}-${readPart('day')}T${readPart('hour')}:${readPart('minute')}:${readPart('second')}`;
}

const toIsoDatePart = (wallClock: string): string => wallClock.slice(0, ISO_DATE_LENGTH);

export const getBangladeshToday = (): string => toIsoDatePart(getBangladeshNow());
